/**
 * A deploy deletes the previous build's chunks, so a tab opened before it
 * fails on its next lazy route. Reloading fetches the new index.html.
 *
 * The event is not prevented: the error still reaches ErrorBoundary, which
 * is what the user sees if the reload itself fails within the guard window.
 */

const RELOADED_AT_KEY = 'stale-chunk-reloaded-at';
const RELOAD_GUARD_MS = 10_000;

export function installReloadOnStaleChunk(): void {
  window.addEventListener('vite:preloadError', () => {
    const reloadedAt = Number(sessionStorage.getItem(RELOADED_AT_KEY) ?? 0);
    if (Date.now() - reloadedAt < RELOAD_GUARD_MS) return;

    sessionStorage.setItem(RELOADED_AT_KEY, String(Date.now()));
    window.location.reload();
  });
}
